import React, { Component } from 'react';
import { connect } from 'react-redux';
import { closeModal } from '../modules/active_modal';
import { enrollCreateShipping } from '../modules/enroll_actions';
import { getEnrollCartProductIds } from '../shared/cookie.js';
import AddressForm from './AddressForm.jsx';
import TermsOfMembership from './CmsTermsOfMembership.jsx';
import EnrollmentBraintreeDropin  from './EnrollmentBraintreeDropin.jsx';

class EnrollCheckout extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isShowing:       false,
      shipping_address: ((props.customer.shipping_address && props.customer.status !== "Cancelled") ? {
        street: props.customer.shipping_address.street,
        city: props.customer.shipping_address.city,
        zip: props.customer.shipping_address.zip,
        state: props.customer.shipping_address.state
      } : {}),
      shipping_error: false,
      cart_error: false
    };
    if(props.customer.status === "Upgrading")
      this.state.customer = {
        first_name: props.customer.first_name,
        last_name: props.customer.last_name,
        email: null,
        password: null
      };
    else if(props.upgradeStatus)
      this.state.customer = {
        first_name: props.customer.first_name,
        last_name: props.customer.last_name
      };
    this.toggleShowingState = this.toggleShowingState.bind(this);
    this.validateShipping = this.validateShipping.bind(this);
    this.validateCart = this.validateCart.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.validateCheckout = this.validateCheckout.bind(this);
    this.clearShippingErrorMsg = this.clearShippingErrorMsg.bind(this);
  }

  componentWillReceiveProps(nextProps){
    if (nextProps.customer.shipping_address !== this.props.customer.shipping_address)
      this.setState({
        shipping_address: nextProps.customer.shipping_address ?
          ({
            street: nextProps.customer.shipping_address.street,
            city: nextProps.customer.shipping_address.city,
            zip: nextProps.customer.shipping_address.zip,
            state: nextProps.customer.shipping_address.state
          }) : {},
          customer: nextProps.customer.first_name || nextProps.customer.last_name ?
          {
            first_name: nextProps.customer.first_name,
            last_name: nextProps.customer.last_name
          } : {}
      });
  }

  handleChange( sLabel, sObjectType, event ) {
    let oActiveUpdate       = this.state[ sObjectType ];
    oActiveUpdate[ sLabel ] = event.target.value;
    let oUpdate             = {};
    oUpdate[ sObjectType ]  = oActiveUpdate;
    this.setState( oUpdate );
  }

  validateCheckout(){
    return this.validateCart() && this.validateShipping();
  }

  validateShipping(){
    if( this.state.shipping_address && this.state.shipping_address.street && this.state.shipping_address.city &&
      this.state.shipping_address.state && this.state.shipping_address.zip ) return true;
    this.setState({ shipping_error: "Please fill in shipping info" });
    return false;
  }

  validateCart(){
     if( getEnrollCartProductIds().filter(x => x).length > 0 )
      return true;
    let product = this.props.store.tla === "DVD" ? "DVD": "book";
    this.setState({ cart_error: 'You must have a ' + product + ' in your box to checkout.' });
    return false;
  }

  clearShippingErrorMsg(){
    this.setState({
      shipping_error: false,
      cart_error: false
    });
  }

  toggleShowingState() {
    this.setState({isShowing: !this.state.isShowing });
  }

  componentWillReceiveProps(nextProps){
    //refresh braintree obj, evertime shopping cart is opened
    if( this.refs && this.refs.enrollBraintreeObj && this.props.activeModal !== nextProps.activeModal ){
      if (this.props.activeModal === "cart" ) {
        this.refs.enrollBraintreeObj.getWrappedInstance().braintreeObjDestroy();
      } else if(  nextProps.activeModal === "cart" ) {
        this.refs.enrollBraintreeObj.getWrappedInstance().braintreeObjCreate(this.props.customer ? this.props.customer.braintree_token : null, this.props.store.tla)
      }
    }
  }

  doNothing(evt) {
    evt.preventDefault();
    //@TODO what on earth?, form is still submitting...yelp. terms of membership is checked off by default =|
  }


  render() {
     let oCheckout = (
      <div>
        <p>Please Wait...</p>
      </div>
    );
    let oCartErrorMessaging  = '';
    let oFirstRowItem        = this.props.computedCart.items[0];
    let oSecondRowItem       = this.props.computedCart.items[1];
    let firstRow             = '';
    let secondRow            = '';
    let {dispatch}           = this.props;
    let book                 = this.props.store.tla === "DVD" ? "DVD" : "book";
    let prettySubtotal       = parseFloat(this.props.computedCart.subtotal).toFixed(2);
    let shippingErrorMsg     = this.state.shipping_error ? (<p className='errorMessage'>{this.state.shipping_error}</p>) : '';
    let cartErrorMsg         = this.state.cart_error ? (<p className='errorMessage'>{this.state.cart_error}</p>) : '';

if (!oFirstRowItem) {
      firstRow = (
        <tr className="nm-cart-item">
          <td className="col-1">
            <div className="nm-cart-item-wrapper empty"></div>
         </td>
          <td colSpan="2">
            <div className="cartItemMessageBox">
              <h5>Add any {book} for $11.99!</h5>
              <h5><a className="no-wrap" onClick={() => dispatch( closeModal() )}>CONTINUE SHOPPING</a></h5>
            </div>
          </td>
        </tr>
      )
    } else {
      firstRow =(
        <tr className="nm-cart-item">
          <td className="col-1">
            <div className="nm-cart-item-wrapper">
              <img src={"//s3.amazonaws.com/bookspan-media/covers/thumb/" + oFirstRowItem.mmid + ".jpg"} />
           </div>
         </td>
         <td className="col-2">
           <span className="title">{oFirstRowItem.title}</span>
           <br />
           {oFirstRowItem.author}
         </td>
        <td className="col-3">${oFirstRowItem.computed_price.toFixed(2)}</td>
      </tr>
      )
    }

    if (!oSecondRowItem) {
      secondRow = (
        <tr className="nm-cart-item">
          <td className="col-1">
            <div className="nm-cart-item-wrapper empty"></div>
         </td>
          <td colSpan="2">
            <div className="cartItemMessageBox">
              <h5>Add three {book}s for ${this.props.store.second_book} each and get Free Shipping. </h5>
              <h5><a onClick={() => dispatch( closeModal() )}>CONTINUE SHOPPING</a></h5>
            </div>
          </td>
        </tr>
      )
    } else {
      secondRow =(
        <tr className="nm-cart-item">
          <td className="col-1">
              <div className="nm-cart-item-wrapper">
                <img src={"//s3.amazonaws.com/bookspan-media/covers/thumb/" + oSecondRowItem.mmid + ".jpg"} />
             </div>
           </td>
           <td className="col-2">
             <span className="title">{oSecondRowItem.title}</span>
             <br />
             {oSecondRowItem.author}
           </td>
          <td className="col-3">${oSecondRowItem.computed_price.toFixed(2)}</td>
        </tr>
      )
    }

    if (this.props.customer.braintree_token) {
      oCheckout = (
        <div className="info-edit-form showing" >
            <div className="full-width">
              <h4 className="alt">Billing Information</h4>
              <EnrollmentBraintreeDropin
                ref='enrollBraintreeObj'
                upgradeFlow                 = {this.props.upgradeFlow}
                uniqueContainer             = "enroll-payment-form"
                shipping_address            = {this.state.shipping_address}
                customer_obj                = {this.state.customer}
                clearShippingErrorMsg       = {this.clearShippingErrorMsg}
                validateCheckout            = {this.validateCheckout}
                store                       = {this.state.store}
                />
            </div>
            <div className="center">
              {/* @TODO Remove - Temp image for layout until it loads form symantic */}
              <img src={"/images/" + this.props.store.tla.toLowerCase() + "/vseal.gif"} width="100px" height="58px"/>
              <script type="text/javascript" src={"https://seal.websecurity.norton.com/getseal?host_name=" + this.props.store.url  + "&amp;size=S&amp;use_flash=NO&amp;use_transparent=YES&amp;lang=en"}></script>
            </div>
        </div>
      );
    }

    return (
      <div className="info-edit-form showing" >
       <div className="col-70">
          <div className="half-col left">
           <form onSubmit={this.doNothing}>
              <h4 className="alt">{ this.props.upgradeFlow ? "Confirm or Edit Your Account" : "Shipping Information"}</h4>
              { shippingErrorMsg }
              <AddressForm handleChange={this.handleChange}
                upgradeFlow={this.props.upgradeFlow}
                customerStatus={this.props.customer.status}
                customer={this.state.customer}
                shipping_address={this.state.shipping_address}
                shipping_error={this.state.shipping_error} />
            </form>
            </div>
            <div className="half-col">
              {oCheckout}
            </div>
            <div className={"terms-of-membership-box hidden unselectable" + (this.state.isShowing ? " showing" + (this.props.upgradeFlow ? " extra-spacing": "") : "")}>
              <TermsOfMembership />
            </div>
      </div>

        <div className="col-30 mobile-show">
          <h4 className="alt">Order Summary</h4>
          { cartErrorMsg }
          <table className="cart-order-items">
            <tbody>
              {firstRow}
              {secondRow}
            </tbody>
          </table>
          <div className="cart-order-summary">
            <div className="section" id="cart-totals">
              <div className="clearfix">
                  <div className="float-left">Subtotal</div>
                  <div className="float-right">${prettySubtotal}</div>
              </div>
              <div className="clearfix">
                  <div className="float-left">Shipping</div>
                  <div className="float-right">{!this.props.computedCart.shipping ? 'FREE' : '$' + this.props.computedCart.shipping.toFixed(2) }</div>
              </div>
              <div className="clearfix">
                  <div className="float-left">Estimated Tax</div>
                  <div className="float-right">${this.props.computedCart.tax.toFixed(2)}</div>
              </div>
              <div className="clearfix total">
                  <div className="float-left"><strong>Total</strong></div>
                  <div className="float-right"><strong>${this.props.computedCart.total.toFixed(2)}</strong></div>
              </div>
            </div>
          </div>
        </div>

      </div>
    );
  }
};


function mapStateToProps(state){
    return {
      'upgradeStatus': state.upgradeStatus,
      'activeModal': state.activeModal,
      'customer': state.customer,
      'store': state.store,
      'computedCart': state.computedCart
    };
}

export default connect(mapStateToProps)(EnrollCheckout);



// WEBPACK FOOTER //
// ./src/components/EnrollCheckout.jsx